import { useEffect } from 'react';

export default function useOnEscapeKey(handler) {
  useEffect(() => {
    const handleKeyboard = event => {
      if (event.key.toLowerCase() === 'escape') {
        handler();
      }
    };

    window.addEventListener('keydown', handleKeyboard);

    return () => {
      window.removeEventListener('keydown', handleKeyboard);
    };
  }, [handler]);
}
